import request from '@/utils/request'


// 查询商品税点配置列表
export function listGoodsTax(query) {
  return request({
    url: '/biz/admin/goods/goods/tax/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品税点配置分页
export function pageGoodsTax(query) {
  return request({
    url: '/biz/admin/goods/goods/tax/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品税点配置详细
export function getGoodsTax(data) {
  return request({
    url: '/biz/admin/goods/goods/tax/detail',
    method: 'get',
    params: data
  })
}

// 新增商品税点配置
export function addGoodsTax(data) {
  return request({
    url: '/biz/admin/goods/goods/tax/add',
    method: 'post',
    data: data
  })
}

// 修改商品税点配置
export function updateGoodsTax(data) {
  return request({
    url: '/biz/admin/goods/goods/tax/edit',
    method: 'post',
    data: data
  })
}

// 删除商品税点配置
export function delGoodsTax(data) {
  return request({
    url: '/biz/admin/goods/goods/tax/delete',
    method: 'post',
    data: data
  })
}
